<div class="input-field">
  <ng-content></ng-content>
</div>
